import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '../locale'

Vue.use(VueI18n)

const numberFormats = {
  nl: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  },
  de: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  },
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  }
}

const dateTimeFormats = {
  nl: {
    date: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    },
    'date-long': {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }
  },
  de: {
    date: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    },
    'date-long': {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }
  }
}

export const i18n = new VueI18n({
  locale: 'nl',
  fallbackLocale: 'en',
  messages,
  numberFormats,
  dateTimeFormats
})

export default {
  i18n
}



// WEBPACK FOOTER //
// ./src/plugins/vue-i18n.js